export const colors = {
  darkText: "#000000",
  lightText: "#767676",
  primaryColor: "#2663EB",
  white: "#FFFFFF",
  successColor: "#5ABA42",
  strokeDark: "#BEBEBE",
  strokeLight: "#E5E5E5",
  greyBackground: "#F4F4F4",
  failureColor: "#FF4F4F",
  blueBackground: "#EDF3FF",
  warningColor: "#FF9202",
  secondaryColor: "#1DACFF",
  successColorLight: "#bcffac",
  successColorDark: "#1a8200",
  failureColorLight: "#ffcaca",
  failureColorDark: "#be0000",
  warningColorLight: "#FFE1BA",
  primaryColorDark: "#1B50C8",
};
